export default __webpack_public_path__ + "static/media/step2.4902212b.png";